/**
 * @generated SignedSource<<5709b974b5864520755873e6ee8cbbb0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDepositPaymentDetail_item$data = {
  readonly serviceId: string | null;
  readonly isDepositAvailable: boolean;
  readonly " $fragmentType": "PdpSharedDepositPaymentDetail_item";
};
export type PdpSharedDepositPaymentDetail_item$key = {
  readonly " $data"?: PdpSharedDepositPaymentDetail_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDepositPaymentDetail_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDepositPaymentDetail_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        }
      ],
      "kind": "ScalarField",
      "name": "isDepositAvailable",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "2b79e2b42ebb3c9746128ed3d5a4f7b0";

export default node;
